module.exports = __webpack_public_path__ + "static/media/linkedin-icon.a768085e.svg";